import React from 'react';
import { motion } from 'framer-motion';

interface ProgressBarProps {
    total: number;
    current: number;
    onJumpTo?: (index: number) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ total, current, onJumpTo }) => {
    return (
        <div className="absolute top-4 left-0 right-0 z-50 flex gap-1 px-4 max-w-md mx-auto">
            {Array.from({ length: total }).map((_, index) => (
                <div
                    key={index}
                    className="h-1 flex-1 bg-gray-300 rounded-full overflow-hidden cursor-pointer shadow-sm"
                    onClick={() => onJumpTo && onJumpTo(index)}
                >
                    <motion.div
                        className="h-full bg-[#1C7AD6]"
                        initial={{ width: "0%" }}
                        animate={{
                            width: index < current ? "100%" : index === current ? "100%" : "0%"
                        }}
                        transition={{
                            duration: index === current ? 5 : 0.3, // 5s for current slide
                            ease: "linear"
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default ProgressBar;
